const store = {
    namespaced: true,
    state() {
        return {
            shops: [],
            pageData: null,
            isShowMapModal: false,
            isShopsIsFetching: false
        };
    },
    getters: {
        getShopsContacts(state) {
            return state.shops;
        },
        getPageData(state) {
            return state.pageData;
        },
        getIsShowMapModal(state) {
            return state.isShowMapModal;
        },
        getIsShopsIsFetching(state) {
            return state.isShopsIsFetching;
        }
    },
    mutations: {
        setToggleShopOpen(state, shopId) {
            let shop = state.shops.find(e => e.shopId === shopId);
            shop.isOpen = !shop.isOpen;
        },
        setShops(state, shops) {
            state.shops = shops;
        },
        setPageData(state, data) {
            state.pageData = data;
        },
        setIsShowMapModal(state, flag) {
            state.isShowMapModal = flag;
        },
        setIsShopsIsFetching(state, flag) {
            state.isShopsIsFetching = flag;
        }
    },
    actions: {
        toggleShopOpen(context, shopId) {
            context.commit('setToggleShopOpen', shopId);
        },
        async fetchPageData({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/base/page-contacts/`
                });

                commit('setPageData', res.data[0]);
            } catch (e) {
                console.error(e);
            }
        },

        async fetchPharmacies({ commit }) {
            commit('setIsShopsIsFetching', true);
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/base/contacts/`
                });

                commit('setShops', res.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('setIsShopsIsFetching', false);
            }
        }
    }
};

export default store;
